import { Link as MUILink, LinkProps } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

interface Props extends Omit<LinkProps, "href"> {
  to: string;
}

export const ULink: React.FC<Props> = ({ underline, to, ...innerProps }) => (
  <MUILink
    {...innerProps}
    underline={underline || "none"}
    to={to}
    component={RouterLink}
  />
);
